module.exports = __webpack_public_path__ + "img/hero_mobile_1.46fe3c9e.webp";